import { render, staticRenderFns } from "./PaidValue.vue?vue&type=template&id=2d370223&"
import script from "./PaidValue.vue?vue&type=script&lang=js&"
export * from "./PaidValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports